import LegalLayout from "@/pages/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" testId="impressum-page">
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">Angaben gemäß § 5 TMG</h2>
        <p className="mt-2">
          LLP Zaun&Garten<br />
          Inhaber: Anatoli Zygankow<br />
          Hummelbecker Str. 18<br />
          32429 Minden
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">Kontakt</h2>
        <p className="mt-2">
          Telefon: <a href="tel:+4917641162064" className="text-[#244A32] font-medium" data-testid="impressum-phone-link">0176 41162064</a><br />
          E-Mail: <a href="mailto:LLP.service@web.de" className="text-[#244A32] font-medium" data-testid="impressum-email-link">LLP.service@web.de</a>
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
        <p className="mt-2">Anatoli Zygankow, Anschrift wie oben</p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">Haftung für Inhalte</h2>
        <p className="mt-2">
          Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
          Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
          Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-semibold text-[#1A1C19] text-lg">Streitschlichtung</h2>
        <p className="mt-2">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Wir sind nicht
          bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>
    </LegalLayout>
  );
}
